import { render, staticRenderFns } from "./addadministrator.vue?vue&type=template&id=7a9960ac&scoped=true&"
import script from "./addadministrator.vue?vue&type=script&lang=js&"
export * from "./addadministrator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9960ac",
  null
  
)

export default component.exports